<template>
  <div class="problem">
    <div
      class="header x-flex x-row-between x-col-center x-m-b-7 x-p-l-20 x-p-r-20"
    >
      <div class="x-flex">
        <div class="x-w440">
          <el-checkbox class="x-w50" v-model="checkAll">全部</el-checkbox>
          <el-checkbox class="x-w50" v-model="checkAwaitFeedback"
            >待反馈</el-checkbox
          >
          <el-checkbox class="x-w50" v-model="checkAwaitHandle"
            >待处理</el-checkbox
          >
          <el-checkbox class="x-w50" v-model="checkHandleing"
            >处理中</el-checkbox
          >
          <el-checkbox class="x-w50" v-model="checkSuccess">已完成</el-checkbox>
        </div>
        <el-input
          placeholder="手机号 联系人 公司名查询"
          v-model="problemInputVal"
          size="medium"
          style="width: 300px"
          class="x-m-r-12 x-flex-1"
        >
          <el-button slot="append">搜索</el-button>
        </el-input>
        <el-checkbox v-model="checkVague">模糊</el-checkbox>
      </div>
      <div>
        <el-button
          size="medium"
          type="danger"
          style="padding: 10px 30px"
          @click="fEditOrAdd('ADD')"
          >增加</el-button
        >
      </div>
    </div>
    <el-card style="position: relative" class="x-p-b-40">
      <div style="height: calc(100vh - 200px)">
        <vxe-table
          border
          resizable
          highlight-hover-row
          height="100%"
          :data="dataList"
          align="center"
        >
          <vxe-column
            field="idx"
            title="序号"
            min-width="50"
            fixed="left"
          ></vxe-column>
          <vxe-column title="处理状态" min-width="80">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                style="color: #f76062; cursor: default"
                v-if="scope.row.state == '待处理'"
              >
                {{ scope.row.state }}
              </el-button>
              <el-button
                type="text"
                size="mini"
                style="color: #2c8ff2; cursor: default"
                v-if="scope.row.state == '处理中'"
              >
                {{ scope.row.state }}
              </el-button>
              <el-button
                type="text"
                size="mini"
                style="cursor: default"
                v-if="scope.row.state == '待反馈'"
              >
                {{ scope.row.state }}
              </el-button>
              <el-button
                type="text"
                size="mini"
                style="color: #67c23a; cursor: default"
                v-if="scope.row.state == '已完成'"
              >
                {{ scope.row.state }}
              </el-button>
            </template>
          </vxe-column>
          <vxe-column field="appEdition" title="软件版本" min-width="80">
          </vxe-column>
          <vxe-column field="phone" title="绑定手机号" min-width="110">
          </vxe-column>
          <vxe-column field="describe" title="描述" min-width="150">
          </vxe-column>
          <vxe-column field="handler" title="处理人" min-width="90">
          </vxe-column>
          <vxe-column
            field="planSucessTime"
            title="计划完成时间"
            min-width="160"
          >
          </vxe-column>
          <vxe-column field="remarks" title="备注" min-width="150">
          </vxe-column>
          <vxe-column field="submitter" title="提交人" min-width="90">
          </vxe-column>
          <vxe-column field="subTime" title="提交时间" min-width="160">
          </vxe-column>
          <vxe-column
            fixed="right"
            title="操作"
            min-width="70"
            style="margin-bottom: 20px"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="fEditOrAdd('EDIT', scope.row)"
                class="x-m-l-4 x-m-r-20"
                style="color: #2c8ff2"
              >
                修改
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
        <div class="x-flex x-row-between">
          <div
            style="position: absolute; bottom: 15px; left: 20px; z-index: 999"
          >
            共 {{ TP }} 页 {{ TR }} 条
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="Number(TR)"
            @current-change="fCurrentChange"
            style="position: absolute; bottom: 15px; right: 20px; z-index: 999"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog
      :visible.sync="addOrEditProblem"
      width="700px"
      :show-close="false"
      :close-on-click-modal="false"
      class="add-dialog"
      top="8vh"
    >
      <div class="dialog-title x-flex x-row-between x-m-t-0">
        <div class="x-font-15 f600">
          {{ problemAddOrEdit == "ADD" ? "问题增加" : "问题修改" }}
        </div>
        <div class="x-flex">
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <!-- 软件版本  -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex x-m-t-15" :span="24">
          <div class="x-w140 x-text-l x-p-r-15 x-font-13">软件版本</div>
          <el-input
            size="small"
            class="x-flex-1"
            v-model="problemInfo.appEdition"
          ></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15" :span="24">
          <div class="x-w140 x-text-l x-p-r-15 x-font-13">绑定手机号</div>
          <el-input
            size="small"
            class="x-flex-1"
            v-model="problemInfo.phone"
          ></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15 x-col-start" :span="24">
          <div
            class="x-w140 x-text-l x-p-r-15 x-font-13"
            style="color: #2c6ff2"
          >
            在此处与工程师交流
          </div>
          <el-input
            size="small"
            class="x-flex-1"
            :rows="5"
            v-model="problemInfo.textVal"
            placeholder="请输入您的意见或者建议"
            type="textarea"
          ></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15 x-col-start" :span="24">
          <div
            class="x-w140 x-text-l x-p-r-15 x-font-13"
            style="flex: 0 0 140px"
          >
            上传图片（选填）
          </div>
          <div class="x-flex x-flex-wrap">
            <div
              class="upload-img x-m-r-10 x-m-b-10"
              v-for="(item, index) in imgList"
              :key="index"
            >
              <img :src="item" style="width: 100%; height: 100%" />
              <div class="del-img">
                <i
                  class="el-icon-delete"
                  @click="fDelUploadImgList(index)"
                  style="cursor: pointer"
                ></i>
              </div>
            </div>
            <!-- <div style="width: 500px; height: 200px; background-color: #999">
              <img
                :src="item"
                alt=""
                v-for="(item, index) in imgList"
                :key="index"
              />
            </div> -->
            <!-- <div
              class="
                upload-img-btn
                x-flex x-col-center x-row-center x-m-r-10 x-m-b-10
              "
              @click="selectImg"
            >
              <input type="file" id="filed" hidden="" @change="filePreview" />
              <div>
                <i class="el-icon-circle-plus-outline"></i>
                <div class="c-8 x-font-10 x-m-t-4">上传图片</div>
              </div>
            </div> -->
            <el-upload
              action="https://up-z1.qiniup.com/"
              list-type="picture-card"
              :auto-upload="false"
              :data="QiNiuData"
              ref="upload"
              :multiple="true"
              accept="image/jpeg,image/gif,image/png"
              :before-upload="fBeforeImageUpload"
              :on-success="fSuccess"
              :on-error="fError"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <!-- <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog> -->
          </div>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button
          type="danger"
          size="small"
          @click="fSaveProblem"
          style="padding: 10px 30px; margin-right: 10px"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkAll: "", // 全部
      checkAwaitFeedback: "", // 待反馈
      checkAwaitHandle: "", // 待处理
      checkHandleing: "", // 处理中
      checkSuccess: "", // 已完成
      checkVague: "", // 模糊
      problemInputVal: "", // 搜索输入框
      addOrEditProblem: false,
      problemAddOrEdit: "ADD",
      TP: 2,
      TR: 16,
      dataList: [
        {
          idx: 1,
          state: "待处理", // 处理状态
          appEdition: "3.0", // 软件版本
          phone: "16423647876", // 绑定手机号
          describe: "哈哈哈", // 描述
          handler: "小北", // 处理人
          planSucessTime: "2021-09-29 00:00:00", // 计划完成时间
          remarks: "备注", // 备注
          submitter: "憨憨", // 提交人
          subTime: "2021-04-23 00:00:00", // 提交时间
        },
      ],
      problemInfo: {
        appEdition: "2.34", // 软件版本
        phone: "16423647876", // 绑定手机号
        textVal: "",
      },
      imgList: [],
      QiNiuData: {
        // 图片上传是携带的参数
        token: "",
        key: "1",
      },
      imageUrl: "p400/bykSell/" + new Date().getTime(), // 上传后 完整的图片地址
    };
  },
  methods: {
    fSuccess(res, file, fileList) {
      // this.imageUrl = URL.createObjectURL(file.row);
      this.imageUrl =
        "http://7nbui.91byk.com/" +
        res.split(":")[1].split(",")[0].split('"')[1];
      
      
      
    },
    fError(err, file, fileList) {
      
    },
    fBeforeImageUpload(file) {
      
      let imgType = ".jpg";
      if (file.type == "image/png") {
        imgType = ".png";
      } else if (file.type == "image/gif") {
        imgType = ".gif";
      }
      this.QiNiuData.key = "p400/bykSell/" + new Date().getTime() + imgType;
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    // submitUpload() {
    //   this.$refs.upload.submit();
    // },
    // handleRemove(file, fileList) {
    //   console.log(file, fileList);
    // },
    fCurrentChange() {},
    // // 修改提交的问题
    fEditOrAdd(type, row) {
      this.problemAddOrEdit = type;
      this.addOrEditProblem = true;
    },
    async fSaveProblem() {
      let { data } = await this.bykApi.zmCloudApi.fGetQiNiuToken(
        "18957102098",
        "byk-user-img"
      );
      
      if (data.result != "sucess") {
        return this.$message(data.msg);
      }
      this.QiNiuData.token = data.data;
      this.$refs.upload.submit();
    },
    // submitUpload() {
    //   this.$refs.upload.submit();
    // },
    // 添加/修改问题 弹框 取消按钮
    fClose() {
      this.addOrEditProblem = false;
    },
    // 图片上传
    // selectImg() {
    //   document.getElementById("filed").click();
    // },
    // // 选择图片
    // async filePreview(e) {
    //   let res = await this.bykApi.smCom.fSmCompressImg(e.target.files[0]);
    //   console.log(res.path);
    //   this.imgList.push(res.path);
    // },
    // // 删除上传图片列表的指定图片
    // fDelUploadImgList(index) {
    //   console.log(index);
    //   this.imgList.splice(index, 1);
    // },
  },
};
</script>

<style lang="less" scoped>
.problem {
  .header {
    /deep/ .el-input-group__append {
      background-color: #409eff;
      color: #fff;
      border: 1px solid #409eff;
    }
  }

  .upload-img {
    width: 110px;
    height: 110px;
    background-color: rgb(245, 245, 245);
    border-radius: 3px;
    overflow: hidden;
    position: relative;
    .del-img {
      width: 110px;
      height: 110px;
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      display: none;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
    }
    &:hover > .del-img {
      display: flex;
    }
  }
  .upload-img-btn {
    width: 110px;
    height: 110px;
    // line-height: 110px;
    background-color: #fff;
    border: 2px solid rgb(236, 236, 236);
    border-radius: 3px;
    // display: flex;
    // align-content: center;
    // justify-content: center;
    .el-icon-circle-plus-outline {
      font-size: 50px;
      color: rgb(236, 236, 236);
    }
  }

  /deep/ .add-dialog .el-dialog__body {
    padding: 20px 30px 30px !important;
    // height: 600px;
    // overflow-y: scroll;
  }
  /deep/ .add-dialog .el-dialog__header {
    padding: 10px 0 0 !important;
  }

  .add-dialog {
    .dialog-title {
      line-height: 17px;
      font-size: 14px;
      padding-left: 8px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e6e6e6;
      position: relative;
      &::after {
        content: "";
        display: flex;
        width: 3px;
        height: 14px;
        position: absolute;
        left: 0;
        top: 8px;
        border-left: 3px solid #2c6ff2;
      }
      /deep/ .el-button--small {
        font-size: 14px;
        padding: 7px 15px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/problem.vue